import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import blogVideo from "../asserts/videos/Fox.mp4";
import {
  IconArrowUpRight,
  IconBook2,
  IconCode,
  IconPlayerPlayFilled,
} from "@tabler/icons-react";

import Footer from "../components/Footer";

/* =========================================================
   BLOG POSTS
========================================================= */

const posts = [
  {
    number: "01",
    category: "WE3X Institute",
    type: "Career Guide",
    title: "Which Course Is Best for IT Jobs in 2027?",
    description:
      "A practical guide for students and graduates comparing Full Stack Development, MERN Stack, AI, Data Analytics, Cloud, Cybersecurity and Digital Marketing.",
    route: "/blog/which-course-is-best-for-it-jobs-in-2027",
    icon: IconBook2,
    topics: ["IT Careers", "MERN Stack", "Data Analytics"],
  },
  {
    number: "02",
    category: "WE3X Technologies",
    type: "Business Guide",
    title: "How to Choose the Right Software Company for Your Business",
    description:
      "A complete guide to evaluating software companies based on requirements, expertise, portfolio, communication, value, security, scalability and post-launch support.",
    route: "/blog/how-to-choose-the-right-software-company-for-your-business",
    icon: IconCode,
    topics: ["Software", "Business", "Technology"],
  },
  {
    number: "03",
    category: "WE3X Institute",
    type: "Digital Marketing Guide",
    title: "What Are the Benefits of a Digital Marketing Course?",
    description:
      "Learn how digital marketing training can build practical skills, career opportunities, portfolio experience and freelancing possibilities.",
    route: "/blog/what-are-the-benefits-of-a-digital-marketing-course",
    icon: IconPlayerPlayFilled,
    topics: ["Digital Marketing", "Career Skills", "Freelancing"],
  },
  {
    number: "04",
    category: "WE3X Technologies",
    type: "Web Development Guide",
    title: "6 Benefits of Choosing a Local Web Development Company",
    description:
      "Discover why local web development partnerships improve communication, market understanding, support, customization, and long-term business growth.",
    route: "/blog/6-benefits-of-choosing-a-local-web-development-company",
    icon: IconCode,
    topics: ["Web Development", "Local Business", "SEO"],
  },
];

/* =========================================================
   ANIMATIONS
========================================================= */

const fadeLeft = {
  hidden: {
    opacity: 0,
    x: -35,
  },

  visible: {
    opacity: 1,
    x: 0,

    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const fadeRight = {
  hidden: {
    opacity: 0,
    x: 35,
  },

  visible: {
    opacity: 1,
    x: 0,

    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30,
  },

  visible: {
    opacity: 1,
    y: 0,

    transition: {
      duration: 0.65,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const stagger = {
  hidden: {},

  visible: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

/* =========================================================
   BLOG
========================================================= */

export default function Blog() {
  return (
    <main className="overflow-hidden bg-white text-neutral-950">
      {/* =====================================================
          SECTION 1 — BLOG INTRO + VIDEO
      ===================================================== */}

      <section
        className="
          relative
          border-b
          border-neutral-200
          bg-[#F2F2F2]
          pt-28
          sm:pt-32
          lg:pt-36
        "
      >
        {/* SOFT BACKGROUND DETAIL */}

        <div
          className="
            pointer-events-none
            absolute
            -left-32
            top-10
            h-[350px]
            w-[350px]
            rounded-full
            bg-blue-100/60
            blur-[130px]
          "
        />

        <div
          className="
            relative
            z-10
            mx-auto
            grid
            max-w-7xl
            items-center
            gap-12
            px-5
            pb-16
            sm:px-8
            lg:grid-cols-[0.9fr_1.1fr]
            lg:gap-16
            lg:px-10
            lg:pb-20
          "
        >
          {/* =================================================
              LEFT CONTENT
          ================================================= */}

          <motion.div variants={fadeLeft} initial="hidden" animate="visible">
            {/* LABEL */}

            <div
              className="
                flex
                items-center
                gap-3
                text-[10px]
                font-black
                uppercase
                tracking-[0.22em]
                text-blue-600
              "
            >
              <span className="h-[1px] w-9 bg-blue-600" />
              WE3X Blog
            </div>

            {/* TITLE */}

            <h1
              className="
                merriweather
                mt-5
                max-w-2xl
                text-4xl
                font-black
                tracking-[-0.045em]
                sm:text-5xl
                lg:text-[58px]
                lg:leading-[1.06]
              "
            >
              Practical ideas for
              <span className="block text-blue-600">
                learning & technology.
              </span>
            </h1>

            {/* SMALL PARA */}

            <p
              className="
                mt-6
                max-w-xl
                text-[15px]
                leading-8
                text-neutral-600
                sm:text-[16px]
              "
            >
              Explore practical guides from WE3X Institute and WE3X Technologies
              covering IT careers, software development, digital skills and
              smarter technology decisions for students and businesses.
            </p>
           
          </motion.div>

          {/* =================================================
    RIGHT ANIMATED FOX VIDEO
================================================= */}

          <motion.div
            variants={fadeRight}
            initial="hidden"
            animate="visible"
            className="
    relative
    flex
    w-full
    items-center
    justify-center
    lg:-mr-10
    lg:justify-end
    xl:-mr-20
  "
          >
            <div className="relative w-full max-w-[760px] bg-[#F2F2F2]">
              <video
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                className="
      pointer-events-none
      block
      h-auto
      w-full
      object-contain
    "
                style={{
                  WebkitMaskImage:
                    "linear-gradient(to right, transparent 0%, black 8%, black 94%, transparent 100%)",
                  maskImage:
                    "linear-gradient(to right, transparent 0%, black 8%, black 94%, transparent 100%)",
                }}
              >
                <source src={blogVideo} type="video/mp4" />
              </video>

              {/* TEXT BOX */}
              <div
                className="
      absolute
      right-4
      bottom-5
      max-w-[220px]
      rounded-[14px]
      border
      border-white/30
      bg-white/80
      px-4
      py-3
      backdrop-blur-md
      sm:right-5
      sm:bottom-7
    "
              >
                <p className="text-[9px] font-black uppercase tracking-[0.16em] text-blue-600">
                  WE3X Blog
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* =====================================================
          SECTION 2 — BLOG CARDS
      ===================================================== */}

      <section
        className="
          bg-white
          py-20
          sm:py-24
          lg:py-28
        "
      >
        <div
          className="
            mx-auto
            max-w-7xl
            px-5
            sm:px-8
            lg:px-10
          "
        >
          {/* =================================================
              SECTION HEADING
          ================================================= */}

          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.3,
            }}
            className="
              mb-12
              flex
              flex-col
              gap-5
              border-b
              border-neutral-200
              pb-8
              sm:flex-row
              sm:items-end
              sm:justify-between
            "
          >
            <div>
              <div
                className="
                  flex
                  items-center
                  gap-3
                  text-[10px]
                  font-black
                  uppercase
                  tracking-[0.2em]
                  text-blue-600
                "
              >
                <span className="h-[1px] w-8 bg-blue-600" />
                Latest Insights
              </div>

              <h2
                className="
                  merriweather
                  mt-4
                  text-3xl
                  font-black
                  tracking-[-0.04em]
                  sm:text-4xl
                  lg:text-[48px]
                "
              >
                Explore our
                <span className="text-blue-600"> latest stories.</span>
              </h2>
            </div>

            <p
              className="
                max-w-md
                text-[13px]
                leading-7
                text-neutral-500
              "
            >
              Practical articles created for students, developers, entrepreneurs
              and businesses looking for useful technology knowledge.
            </p>
          </motion.div>

          {/* =================================================
              BLOG CARDS
          ================================================= */}

          <motion.div
            variants={stagger}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.12,
            }}
            className="
              grid
              gap-6
              md:grid-cols-2
            "
          >
            {posts.map((post) => {
              const PostIcon = post.icon;

              return (
                <motion.div
                  key={post.route}
                  variants={fadeUp}
                  whileHover={{
                    y: -6,
                  }}
                  transition={{
                    duration: 0.3,
                  }}
                  className="h-full"
                >
                  {/* =============================================
                      ENTIRE CARD IS A LINK
                  ============================================= */}

                  <Link
                    to={post.route}
                    className="
                      group
                      relative
                      flex
                      h-full
                      min-h-[400px]
                      flex-col
                      overflow-hidden
                      rounded-[26px]
                      border
                      border-neutral-200
                      bg-[#fafafa]
                      p-6
                      transition-all
                      duration-300
                      hover:border-blue-200
                      hover:bg-white
                      hover:shadow-[0_25px_60px_rgba(0,0,0,0.06)]
                      sm:p-8
                    "
                  >
                    {/* BACKGROUND NUMBER */}

                    <span
                      className="
                        pointer-events-none
                        absolute
                        -right-2
                        -top-7
                        text-[130px]
                        font-black
                        leading-none
                        tracking-[-0.1em]
                        text-neutral-100
                        transition-colors
                        duration-300
                        group-hover:text-blue-50
                      "
                    >
                      {post.number}
                    </span>

                    {/* TOP */}

                    <div
                      className="
                        relative
                        z-10
                        flex
                        items-center
                        justify-between
                        gap-4
                      "
                    >
                      <div
                        className="
                          flex
                          h-12
                          w-12
                          items-center
                          justify-center
                          rounded-[14px]
                          border
                          border-neutral-200
                          bg-white
                          text-blue-600
                          transition-all
                          duration-300
                          group-hover:border-blue-600
                          group-hover:bg-blue-600
                          group-hover:text-white
                        "
                      >
                        <PostIcon size={21} stroke={1.8} />
                      </div>

                      <span
                        className="
                          rounded-full
                          border
                          border-neutral-200
                          bg-white
                          px-3
                          py-1.5
                          text-[8px]
                          font-black
                          uppercase
                          tracking-[0.14em]
                          text-neutral-500
                        "
                      >
                        {post.type}
                      </span>
                    </div>

                    {/* CATEGORY */}

                    <div
                      className="
                        relative
                        z-10
                        mt-10
                        text-[10px]
                        font-black
                        uppercase
                        tracking-[0.18em]
                        text-blue-600
                      "
                    >
                      {post.category}
                    </div>

                    {/* TITLE */}

                    <h3
                      className="
                        merriweather
                        relative
                        z-10
                        mt-3
                        max-w-xl
                        text-[26px]
                        font-black
                        leading-[1.2]
                        tracking-[-0.035em]
                        text-neutral-950
                        sm:text-[30px]
                      "
                    >
                      {post.title}
                    </h3>

                    {/* DESCRIPTION */}

                    <p
                      className="
                        relative
                        z-10
                        mt-5
                        max-w-xl
                        text-[13px]
                        leading-7
                        text-neutral-600
                      "
                    >
                      {post.description}
                    </p>

                    {/* TAGS */}

                    <div
                      className="
                        relative
                        z-10
                        mt-6
                        flex
                        flex-wrap
                        gap-2
                      "
                    >
                      {post.topics.map((topic) => (
                        <span
                          key={topic}
                          className="
                            rounded-full
                            bg-white
                            px-3
                            py-1.5
                            text-[9px]
                            font-bold
                            text-neutral-500
                          "
                        >
                          {topic}
                        </span>
                      ))}
                    </div>

                    {/* CARD BOTTOM */}

                    <div
                      className="
                        relative
                        z-10
                        mt-auto
                        flex
                        items-center
                        justify-between
                        border-t
                        border-neutral-200
                        pt-6
                      "
                    >
                      <div
                        className="
                          flex
                          items-center
                          gap-2
                          text-sm
                          font-black
                          text-neutral-950
                          transition-colors
                          duration-300
                          group-hover:text-blue-600
                        "
                      >
                        Read full article
                        <IconArrowUpRight
                          size={16}
                          className="
                            transition-transform
                            duration-300
                            group-hover:-translate-y-1
                            group-hover:translate-x-1
                          "
                        />
                      </div>

                      <span
                        className="
                          hidden
                          text-[8px]
                          font-black
                          uppercase
                          tracking-[0.14em]
                          text-neutral-300
                          sm:block
                        "
                      >
                        WE3X Blog
                      </span>
                    </div>

                    {/* HOVER LINE */}

                    <span
                      className="
                        absolute
                        bottom-0
                        left-0
                        h-[3px]
                        w-0
                        bg-blue-600
                        transition-all
                        duration-500
                        group-hover:w-full
                      "
                    />
                  </Link>
                </motion.div>
              );
            })}
          </motion.div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
